import { RunEnvType } from "../globals";
import { loadScript } from "./loadScript";

const oneTrustEnv: Record<RunEnvType, string> = {
  qa: "49b8ee17-a63a-4e6b-a0dc-050aa38972f8-test",
  production: "49b8ee17-a63a-4e6b-a0dc-050aa38972f8"
};

export function initOneTrust(): void {
  const oneTrustDataDomain = oneTrustEnv[RUN_ENV];
  if (oneTrustDataDomain === undefined) {
    throw new Error(
      "oneTrustDataDomain is not set! This is probably caused by RUN_ENV (" +
        RUN_ENV +
        ") not being a valid key for oneTrustEnv."
    );
  }
  loadScript("https://cdn.cookielaw.org/scripttemplates/otSDKStub.js", {
    "data-domain-script": oneTrustDataDomain
  });
}
